import { Link } from "react-router-dom";
import { Eyebrow, Reveal } from "./Reveal";
import { CityLinks } from "./SeoLinks";

export const ServiceArea = () => (
  <section id="area" data-testid="service-area-section" className="relative overflow-hidden bg-[#0D0D0B] py-24 sm:py-32">
    <div className="pointer-events-none absolute right-0 top-0 h-full w-1/2 opacity-[0.07] [background-image:radial-gradient(#F2EEE6_1px,transparent_1px)] [background-size:22px_22px]" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <Eyebrow>Service area</Eyebrow>
        <h2 className="font-display mt-4 text-6xl uppercase leading-[0.9] text-[#F2EEE6] sm:text-8xl">Greenville,<br /><span className="text-[#FFB000]">South Carolina</span><br />& nearby.</h2>
        <p className="mt-6 max-w-md text-base text-[#d6d2c8] sm:text-lg">Locally based in Greenville and serving the surrounding Upstate South Carolina area. Not sure if we reach you? <Link to="/junk-removal/greenville-sc" className="font-bold text-[#FFB000] underline-offset-4 hover:underline">See our Greenville page</Link> or call and ask.</p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-6 lg:pt-10">
        <CityLinks />
      </Reveal>
    </div>
  </section>
);
